module.exports = __webpack_public_path__ + "images/avatar-placeholder.d1d59f15.png";